import type { WorkflowEdge } from 'flow/service/graph';
import { COLUMN_SPACING, getIdsFromEdgeId, isImportedTailNodeId } from 'flow/service/graph';

export function getEdgeCenterX(args: {
  sourceX: number;
  targetX: number;
  edgeId: WorkflowEdge['id'];
}) {
  const { sourceX, targetX, edgeId } = args;

  const { sourceId } = getIdsFromEdgeId(edgeId);
  const isImportedTailNode = isImportedTailNodeId(sourceId);

  return isImportedTailNode
    // computes edge center that bends near the source node
    ? sourceX + (COLUMN_SPACING / 2)
    // computes edge center that bends near the target node
    : targetX - (COLUMN_SPACING / 2);
}
